// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1FptU","left":"styles_left__F39IS","desktopActions":"styles_desktopActions__19hWl","title":"styles_title__3VqF-"};